import React, { FC, useEffect, useRef, useState } from 'react';
import { Tag, Input, Tooltip, Row, Col } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { InputRef } from 'antd';

const TagInput: FC<{
  value?: string[];
  onChange?: any;
  placeholder?: any;
}> = ({
  value,
  onChange,
  placeholder
}) => {
  const [tags, setTags] = useState<string[]>(value || []);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);

  const handleClose = (removedTag: string) => {
    const newTags = tags.filter(tag => tag !== removedTag);
    setTags(newTags);
    onChange(newTags)
  };

  const showInput = () => {
    setInputVisible(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    if (inputValue && tags.indexOf(inputValue) === -1) {
      setTags([...tags, inputValue]);
      onChange([...tags, inputValue])
    }
    setInputVisible(false);
    setInputValue('');
  };

  return (
    <Row className="custom-tag"> 
      <Col span={24} className="file-wrapper">
        <Input
          ref={inputRef}
          type="text"
          size="small"
          className="tag-input"
          placeholder={placeholder || "Input tag here..."}
          value={inputValue}
          onChange={handleInputChange}
          onPressEnter={handleInputConfirm}
        />
        <hr />
        {tags.map((tag, index) => 
          <Tag
            className="tag-item"
            key={tag}
            closable
            onClose={() => handleClose(tag)}
          >
            <span>{tag}</span>
          </Tag>
        )}
      </Col>
    </Row>
  );
};

export default TagInput;
